import React from 'react';
import { Waves, Wrench, Sparkles, FlaskConical, Layers, Flame, Droplets, Plus } from 'lucide-react';
type Service = {
  icon: React.ReactNode;
  title: string;
  description: string;
};
const services: Service[] = [{
  icon: <Waves size={28} data-id="element-125" />,
  title: 'Monthly Pool Service',
  description: 'Regular maintenance to keep your pool crystal clear, balanced, and swim-ready all year long.'
}, {
  icon: <Wrench size={28} data-id="element-126" />,
  title: 'Pool Repairs',
  description: 'From pumps and filters to plumbing and equipment — we diagnose and fix it fast.'
}, {
  icon: <Sparkles size={28} data-id="element-127" />,
  title: 'Tile Cleans',
  description: 'Remove calcium buildup and staining to restore your waterline tile to like-new condition.'
}, {
  icon: <FlaskConical size={28} data-id="element-128" />,
  title: 'Acid & Chlorine Washes',
  description: 'Deep-clean treatments that strip algae, stains, and buildup from pool surfaces.'
}, {
  icon: <Layers size={28} data-id="element-129" />,
  title: 'Hardscape',
  description: 'Patio, deck, and surrounding surface cleaning and maintenance for a complete backyard refresh.'
}, {
  icon: <Flame size={28} data-id="element-130" />,
  title: 'Grill Cleaning',
  description: 'Professional deep-clean for your outdoor grill — inside and out, looking brand new.'
}, {
  icon: <Droplets size={28} data-id="element-131" />,
  title: 'Water Features',
  description: 'Fountains, waterfalls, and spa jets — we service and maintain all your water features.'
}, {
  icon: <Plus size={28} data-id="element-132" />,
  title: 'And More!',
  description: 'Have a unique outdoor need? Reach out — we handle a wide range of outdoor living services.'
}];
export function Services() {
  return <section id="services" className="w-full bg-[#0d1117] pt-20 pb-12 sm:py-20 px-4 sm:px-6" data-id="element-133">
      <div className="max-w-6xl mx-auto" data-id="element-134">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-135">
          <span className="text-[#2979ff] text-sm font-bold tracking-widest uppercase" data-id="element-136">
            What We Do
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-white mt-2 mb-4" data-id="element-137">
            Full-Service Outdoor Care
          </h2>
          <p className="text-gray-400 max-w-xl mx-auto text-base sm:text-lg" data-id="element-138">
            One call covers it all. Elite Poolz keeps your entire outdoor living
            space in peak condition.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-139">
          {services.map(service => <div key={service.title} className="bg-[#141b27] border border-[#1e2a3a] rounded-2xl p-6 text-center sm:text-left hover:border-[#2979ff] hover:shadow-lg hover:shadow-[#2979ff]/10 transition-all group" data-id="element-140">
              <div className="text-[#2979ff] mb-4 group-hover:scale-110 transition-transform inline-block" data-id="element-141">
                {service.icon}
              </div>
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-142">
                {service.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-143">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}